export default "__VITE_ASSET__3CLFznpz__"